import { serverTimestamp } from "firebase/firestore";

export const createdAt = () => ({
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp(),
});

export const updatedAt = () => ({
  updatedAt: serverTimestamp(),
});
